/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Theme_DarkInputs */

const en_profile_theme_dark = /** @type {(inputs: Profile_Theme_DarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dark Mode`)
};

const pt_br2_profile_theme_dark = /** @type {(inputs: Profile_Theme_DarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modo Escuro`)
};

/**
* | output |
* | --- |
* | "Dark Mode" |
*
* @param {Profile_Theme_DarkInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const profile_theme_dark = /** @type {((inputs?: Profile_Theme_DarkInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Theme_DarkInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profile_theme_dark(inputs)
	return pt_br2_profile_theme_dark(inputs)
});